import React__default, { useEffect } from 'react';
import classNames from './../external_lib/classnames/index.js';
import Typography from './Typography.js';

function Tabs(_a) {
    var children = _a.children, onTabChange = _a.onTabChange, classes = _a.classes, activeTab = _a.activeTab, leftAlign = _a.leftAlign;
    var _b = React__default.useState(activeTab || 0), currentTab = _b[0], updateCurrentTab = _b[1];
    useEffect(function () { return updateCurrentTab(activeTab || 0); }, [activeTab]);
    var changeTab = function (tabIndex) {
        updateCurrentTab(tabIndex);
        if (typeof onTabChange === 'function')
            onTabChange(tabIndex);
    };
    if (!Array.isArray(children)) {
        children = [children];
    }
    return (React__default.createElement("div", { className: classNames('tabs', classes) },
        React__default.createElement("div", { className: leftAlign ? 'tab__main_left' : 'tab__main_center' }, children.map(function (child, index) {
            var _a;
            return (React__default.createElement("div", { key: index, className: classNames('tab__title', {
                    tab__selected: currentTab === index
                }), onClick: function () { return changeTab(index); } },
                React__default.createElement(Typography, { variant: "headingThree", weight: currentTab === index ? 'semibold' : 'normal' }, (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.label),
                currentTab === index ? (React__default.createElement("div", { className: "tab__underline" })) : null));
        })),
        React__default.createElement("div", { className: "tab__content" }, children[currentTab])));
}

export { Tabs as default };
//# sourceMappingURL=Tabs.js.map
